import { useTranslation } from 'react-i18next';
import { Download } from '@linktivity/link-icons';
import { INBOX_ENABLED } from '@link/share/constants';
import {
  ContractIcon,
  PaymentIcon,
  SupplierIcon,
  OtaIcon,
  NoteIcon,
  OrderIcon
} from '@link/share/icons';
import { SidebarMenu, bottomItems } from '@link/share/layouts';

const Sidebar = () => {
  const { t } = useTranslation();
  const menuItems = [
    {
      label: t('layouts.sidebar.contracts'),
      Icon: ContractIcon,
      name: 'contracts',
      children: [
        {
          label: t('share.views.contractsList.title'),
          to: '/contracts/list'
        },
        {
          label: t('views.whitelist.title'),
          to: '/contracts/whitelist'
        },
        {
          label: t('views.activityPublish.title'),
          to: '/contracts/activity-publish'
        }
      ]
    },
    {
      label: t('layouts.sidebar.suppliers'),
      Icon: SupplierIcon,
      name: 'suppliers',
      children: [
        {
          label: t('views.suppliersList.title'),
          to: '/suppliers/list'
        },
        {
          label: t('share.views.suppliersAccount.title'),
          to: '/suppliers/accounts'
        }
      ]
    },
    {
      label: t('layouts.sidebar.agents'),
      Icon: OtaIcon,
      name: 'agents',
      children: [
        {
          label: t('views.agentsList.title'),
          to: '/agents/list'
        },
        {
          label: t('views.orgList.title'),
          to: '/agents/orgs'
        },
        {
          label: t('views.agentAccountList.title'),
          to: '/agents/accounts'
        },
        {
          label: t('views.apiKeyList.title'),
          to: '/agents/api-keys'
        },
        {
          label: t('views.webHook.title'),
          to: '/agents/web-hook'
        }
        // {
        //   label: t('views.agentsCharge.title'),
        //   to: '/agents/charge'
        // }
      ]
    },
    {
      label: t('layouts.sidebar.activities'),
      name: 'activities',
      to: '/activities',
      Icon: OrderIcon
    },
    {
      label: t('layouts.sidebar.finance'),
      Icon: PaymentIcon,
      name: 'finance',
      children: [
        {
          label: t('views.financeTransactions.title'),
          to: '/finance/transactions'
        },
        {
          label: t('views.financeCharge.title'),
          to: '/finance/charge'
        }
      ]
    },
    {
      label: t('layouts.sidebar.notifications'),
      name: 'notifications',
      Icon: NoteIcon,
      children: [
        ...(INBOX_ENABLED
          ? [
              {
                label: t('share.views.notificationInbox.title'),
                to: '/notifications/inbox'
              }
            ]
          : []),
        {
          label: t('views.notificationsList.title'),
          to: '/notifications/manual'
        }
      ]
    },
    {
      label: t('layouts.sidebar.dataExport'),
      name: 'dataExport',
      to: '/data-export',
      Icon: Download
    }
  ];

  return <SidebarMenu menuItems={menuItems} bottomItems={bottomItems} />;
};

export default Sidebar;
